import { ICurrentUser } from '@samc/common';
import LoanDetailsHandler from '@/LoanDetailsHandler';
import Entitlements from '@/Entitlements';
import { LoadingInterface } from '@samc/centricity-core';

export default class SearchResultNavigationHandler {

  public detailsHandler!: LoanDetailsHandler;
  private entitledToViewLoanDetails: boolean = false;

  public constructor(loading: ReturnType<typeof LoadingInterface>) {
    this.detailsHandler = new LoanDetailsHandler(loading);
  }

  public navigateToSearchResult(domain: string, result: any) {
    if (domain === "Transactions") {
      if (result.PackageType?.toLocaleLowerCase() === 'acquisition')
        window.location.href = '/TransactionManagement/' + result.Id;
      else if (result.PackageType?.toLocaleLowerCase() === 'sell')
        window.location.href = '/TransactionManagement/Deals/' + result.Id;
      else
        console.warn('No result navigation implemented for PackageType, ' + result.PackageType);
    } else if (domain === 'Loan' && this.entitledToViewLoanDetails) {
      // result from L&S view
      this.detailsHandler.onSelection([result.primaryKey ?? result.Id]);
      this.detailsHandler.setActive(true);
      this.detailsHandler.selectItem();
      this.detailsHandler.setActive(false);
    } else {
      console.warn('No result navigation implemented for domain, ' + domain);
    }
  }
  
  public setUserEntitlements(user: ICurrentUser) {
    this.entitledToViewLoanDetails = user
      ? user.hasEntitlement(Entitlements.InventoryManagementModule.ViewLoanDetails)
      : false;

    if (this.entitledToViewLoanDetails) {
      this.detailsHandler.initialize();
      this.detailsHandler.setActive(false);
    }
  }
}